//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from "@/components/Nav";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Graduation",
  components: { Nav, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        loop: false,
        autoplay: true,
        speed: 3000,
        disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      gradulist: "",
      banner: "",
      num: 10, //控制显示查看更多用的
      more:''
    };
  },
  methods: {
    getall() {
      // window.location.href =
      //   "http://mp.weixin.qq.com/mp/homepage?__biz=MzAwMzE3MjczMw==&hid=15&sn=7b728503f7952055d5f418808cc56e2c&scene=18#wechat_redirect";
      window.location.href = this.more
    },
    godetails() {
      // console.log(1);
    },
    gourl(url) {
      if (url != "") {
        window.location.href = url;
      }
    }
  },
  created() {
    this.$api.graduation().then(res => {
      this.gradulist = res.data.data.items;
      this.banner = res.data.data.banner;
      this.more = res.data.data.more;
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/Graduation/graduation.vue